'use client'; // Needed since Splide is a Class component (Can't be in a Server component)

import { EntityListItem, EntityListItemProps } from '@/ui-components/molecules/EntityListItem/EntityListItem';
import { Splide, SplideSlide } from '@splidejs/react-splide';
import '@splidejs/react-splide/css';
import { AutoScroll } from '@splidejs/splide-extension-auto-scroll';
import { BreadthOfContentAccessibilityList } from '../BreadthOfContentAccessibilityList/BreadthOfContentAccessibilityList';
import { breadthOfContentSliderOptions } from '../breadthOfContentSliderOptions';
import styles from './breadthofentitylists.module.scss';
import { columnizeItems } from './columnizeItems';

export interface BreadthOfEntityListsProps {
    items: EntityListItemProps[];
}

const ITEMS_NEEDED_FOR_3_ROWS = 3 * 8; // 3 rows, 8 items each

export default function BreadthOfEntityLists({ items }: BreadthOfEntityListsProps): React.JSX.Element {
    const rowsPerColumn = items.length >= ITEMS_NEEDED_FOR_3_ROWS ? 3 : 2;
    const numberOfColumns = Math.ceil(items.length / rowsPerColumn);

    const columns = columnizeItems(numberOfColumns, items);
    const accessibilityItems = items.map((item, index) => <EntityListItem {...item} key={index} />);

    return (
        <BreadthOfContentAccessibilityList items={accessibilityItems}>
            <Splide options={breadthOfContentSliderOptions} aria-live="off" extensions={{ AutoScroll }}>
                {columns.map((columnItems, columnIndex) => (
                    <SplideSlide key={columnIndex}>
                        {columnItems.map((item, itemIndex) => (
                            <div className={styles.item} key={itemIndex}>
                                <EntityListItem {...item} />
                            </div>
                        ))}
                    </SplideSlide>
                ))}
            </Splide>
        </BreadthOfContentAccessibilityList>
    );
}
